export default __webpack_public_path__ + "static/travel4-2a4d2138dce103036f7bcda89242b501.png";